import React, { Component } from 'react';
import Demo from './Demo/Demo';

class App extends Component {
  render() {
    return <Demo />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js